import { Outlet, Link } from 'react-router-dom';

export default function PublicLayout({ children }: { children?: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-gray-950">
      <nav className="bg-gray-900 shadow-sm border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <Link to="/" className="text-xl font-bold text-primary-400">
                PrimeClick
              </Link>
            </div>
            <div className="flex items-center space-x-4">
              <Link
                to="/restaurante"
                className="text-gray-300 hover:text-white text-sm font-medium"
              >
                Admin
              </Link>
            </div>
          </div>
        </div>
      </nav>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children ?? <Outlet />}
      </main>
    </div>
  );
}
